import { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { AppLoader } from '../../Components/common/AppLoader/AppLoader';
import { useNavigate } from 'react-router-dom';
import { fetchProductsForDisplay, mapProductToCardProps } from '../../api/productApi';
import './BizaarioStorePage.css';
import aboutusBg from "../../assets/images/aboutus-bg.png";

export const BizaarioStorePage = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const rows = await fetchProductsForDisplay();
        if (cancelled) return;
        setProducts(rows.map(mapProductToCardProps));
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load products.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="store-page">
      {/* Hero */}
      <section
        className="store-page__hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">Bizaario Store</p>
            <h1 className="store-page__hero-title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      {/* Products Section */}
      <section className="store-page__products">
        <Container fluid className="px-0">
          <Row className="align-items-start justify-content-between mb-4 store-page__header">
            <Col>
              <h2 className="store-page__title">Bizaario Store</h2>
              <p className="store-page__subtitle">
                Shop smarter for your health — curated medical supplies and wellness products at your fingertips.
              </p>
            </Col>
          </Row>

          {loading && (
            <AppLoader className="py-5" />
          )}

          {!loading && error && (
            <p className="text-center py-4 text-danger">{error}</p>
          )}

          {!loading && !error && (
            <Row xs={1} md={2} lg={3} className="g-5 mt-1">
              {products.length > 0 ? (
                products.map((product) => (
                  <Col key={product.id}>
                    <Card
                      className="bizaario-store__card border-0"
                      role="button"
                      tabIndex={0}
                      onClick={() => navigate(`/store/${product.slug}`)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          navigate(`/store/${product.slug}`);
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="bizaario-store__card-image-wrapper">
                        <Card.Img
                          variant="top"
                          src={product.image}
                          alt={product.title}
                          className="bizaario-store__card-image"
                        />
                      </div>
                      <Card.Body className="bizaario-store__card-body px-0">
                        <Card.Title className="bizaario-store__card-title">
                          {product.title}
                        </Card.Title>
                        <Card.Text className="bizaario-store__card-desc">
                          {product.description}
                        </Card.Text>
                        <Button
                          className="bizaario-store__card-btn w-100"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/store/${product.slug}`);
                          }}
                        >
                          Request a Quote
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <p className="text-center py-4">No products available yet.</p>
                </Col>
              )}
            </Row>
          )}
        </Container>
      </section>
    </div>
  );
};
